sc-express-payment {
  display: block;
}
